import $ from 'jquery'

import Block from '../../common.blocks/block'

export default class LegalNotice extends Block {
	static title = 'legal-notice'

	constructor($el) {
		super($el)

		this.lightbox = this.$el.findElement('lightbox')

		if (!this.lightbox.length) {
			return
		}

		this.$el.findElement('trigger').on('click', () => {
			this.lightbox.removeModifier('hidden')
		})

		this.$el.findElement('close').on('click', () => {
			this.close()
		})

		// backdrop only, not the image itself
		this.lightbox.on('click', (e) => {
			if (e.target === e.currentTarget) {
				this.close()
			}
		})

		$(document).on('keydown', (e) => {
			if (e.key === 'Escape') {
				this.close()
			}
		})
	}

	close() {
		this.lightbox.addModifier('hidden')
	}
}
